// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { getAppByQreIdImportDatabases, getAppByQreIdSurvey, getConfig, getDebugByOperationIdOperationStatusDebug, getDebugSurveyByQreIdCatiexProjectLink, getMetrics, getSampleByOperationIdOperationStatus, getSampleByQreIdMaxIpsosId, getSampleByQreIdOperations, getSampleByQreIdSampleAutocomplete, getSampleRowsByQreIdSampleColumns, getSampleRowsByQreIdSurveyData, getSurveyByQreIdCatiexProjectLink, getSurveyByQreIdQuotaFlatStructure, getSurveyByQreIdResponseCodes, loginWithToken, type Options, postByQreIdCatiExAliasSet, postByQreIdFinalizeSurvey, postByQreIdPreCallInfoSet, postByQreIdQuotaTargetSet, postByQreIdResponseCodesSet, postCommandByQreIdFileExportSample, postCommandChangeSampleResponseCode, postCommandCreateSample, postCommandDeleteSample, postCommandDeleteSampleByDuplicity, postCommandFileImportSample, postCommandFileUpdateSample, postCommandResetSample, postCommandUnblacklistSampleRow, postCommandUpdateSample, postCommandUpdateSampleRow, postDebugByQreIdCatiExAliasSet, postDebugByQreIdFileExportSampleTest, postDebugByQreIdFinalizeSurvey, postDebugByQreIdPreCallInfoSet, postDebugByQreIdQuotaTargetSet, postDebugByQreIdResponseCodesSet, postDebugCatiexProjectCreated, postDebugFileImportSampleTest, postDebugFileUpdateSampleTest, postExternalEventsCatiexProjectCreated, postSampleByQreIdStatus, postSampleRowsByQreIdSampleRowData, postSurveyByQreIdDefaultFilters } from '../sdk.gen';
import type { GetAppByQreIdImportDatabasesData, GetAppByQreIdSurveyData, GetConfigData, GetDebugByOperationIdOperationStatusDebugData, GetDebugSurveyByQreIdCatiexProjectLinkData, GetMetricsData, GetSampleByOperationIdOperationStatusData, GetSampleByQreIdMaxIpsosIdData, GetSampleByQreIdOperationsData, GetSampleByQreIdSampleAutocompleteData, GetSampleRowsByQreIdSampleColumnsData, GetSampleRowsByQreIdSurveyDataData, GetSurveyByQreIdCatiexProjectLinkData, GetSurveyByQreIdQuotaFlatStructureData, GetSurveyByQreIdResponseCodesData, LoginWithTokenData, LoginWithTokenResponse, PostByQreIdCatiExAliasSetData, PostByQreIdCatiExAliasSetError, PostByQreIdCatiExAliasSetResponse, PostByQreIdFinalizeSurveyData, PostByQreIdFinalizeSurveyError, PostByQreIdFinalizeSurveyResponse, PostByQreIdPreCallInfoSetData, PostByQreIdPreCallInfoSetError, PostByQreIdPreCallInfoSetResponse, PostByQreIdQuotaTargetSetData, PostByQreIdQuotaTargetSetError, PostByQreIdQuotaTargetSetResponse, PostByQreIdResponseCodesSetData, PostByQreIdResponseCodesSetError, PostByQreIdResponseCodesSetResponse, PostCommandByQreIdFileExportSampleData, PostCommandByQreIdFileExportSampleError, PostCommandChangeSampleResponseCodeData, PostCommandChangeSampleResponseCodeError, PostCommandChangeSampleResponseCodeResponse, PostCommandCreateSampleData, PostCommandCreateSampleError, PostCommandCreateSampleResponse, PostCommandDeleteSampleByDuplicityData, PostCommandDeleteSampleByDuplicityError, PostCommandDeleteSampleByDuplicityResponse, PostCommandDeleteSampleData, PostCommandDeleteSampleError, PostCommandDeleteSampleResponse, PostCommandFileImportSampleData, PostCommandFileImportSampleError, PostCommandFileImportSampleResponse, PostCommandFileUpdateSampleData, PostCommandFileUpdateSampleError, PostCommandFileUpdateSampleResponse, PostCommandResetSampleData, PostCommandResetSampleError, PostCommandResetSampleResponse, PostCommandUnblacklistSampleRowData, PostCommandUnblacklistSampleRowError, PostCommandUnblacklistSampleRowResponse, PostCommandUpdateSampleData, PostCommandUpdateSampleError, PostCommandUpdateSampleResponse, PostCommandUpdateSampleRowData, PostCommandUpdateSampleRowError, PostCommandUpdateSampleRowResponse, PostDebugByQreIdCatiExAliasSetData, PostDebugByQreIdCatiExAliasSetError, PostDebugByQreIdCatiExAliasSetResponse, PostDebugByQreIdFileExportSampleTestData, PostDebugByQreIdFileExportSampleTestError, PostDebugByQreIdFinalizeSurveyData, PostDebugByQreIdFinalizeSurveyError, PostDebugByQreIdPreCallInfoSetData, PostDebugByQreIdPreCallInfoSetError, PostDebugByQreIdPreCallInfoSetResponse, PostDebugByQreIdQuotaTargetSetData, PostDebugByQreIdQuotaTargetSetError, PostDebugByQreIdQuotaTargetSetResponse, PostDebugByQreIdResponseCodesSetData, PostDebugByQreIdResponseCodesSetError, PostDebugCatiexProjectCreatedData, PostDebugCatiexProjectCreatedError, PostDebugFileImportSampleTestData, PostDebugFileImportSampleTestError, PostDebugFileImportSampleTestResponse, PostDebugFileUpdateSampleTestData, PostDebugFileUpdateSampleTestError, PostDebugFileUpdateSampleTestResponse, PostExternalEventsCatiexProjectCreatedData, PostExternalEventsCatiexProjectCreatedError, PostSampleByQreIdStatusData, PostSampleByQreIdStatusError, PostSampleByQreIdStatusResponse, PostSampleRowsByQreIdSampleRowDataData, PostSampleRowsByQreIdSampleRowDataError, PostSampleRowsByQreIdSampleRowDataResponse, PostSurveyByQreIdDefaultFiltersData, PostSurveyByQreIdDefaultFiltersError, PostSurveyByQreIdDefaultFiltersResponse } from '../types.gen';

/**
 * update sample
 */
export const postCommandUpdateSampleMutation = (options?: Partial<Options<PostCommandUpdateSampleData>>): UseMutationOptions<PostCommandUpdateSampleResponse, PostCommandUpdateSampleError, Options<PostCommandUpdateSampleData>> => {
    const mutationOptions: UseMutationOptions<PostCommandUpdateSampleResponse, PostCommandUpdateSampleError, Options<PostCommandUpdateSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandUpdateSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * unblacklist sample rows - send remaining verified numbers to LBox
 */
export const postCommandUnblacklistSampleRowMutation = (options?: Partial<Options<PostCommandUnblacklistSampleRowData>>): UseMutationOptions<PostCommandUnblacklistSampleRowResponse, PostCommandUnblacklistSampleRowError, Options<PostCommandUnblacklistSampleRowData>> => {
    const mutationOptions: UseMutationOptions<PostCommandUnblacklistSampleRowResponse, PostCommandUnblacklistSampleRowError, Options<PostCommandUnblacklistSampleRowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandUnblacklistSampleRow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getSampleByQreIdSampleAutocompleteQueryKey = (options: Options<GetSampleByQreIdSampleAutocompleteData>) => createQueryKey('getSampleByQreIdSampleAutocomplete', options);

/**
 * Get autocomplete suggestions for sample column
 */
export const getSampleByQreIdSampleAutocompleteOptions = (options: Options<GetSampleByQreIdSampleAutocompleteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSampleByQreIdSampleAutocomplete({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSampleByQreIdSampleAutocompleteQueryKey(options)
    });
};

/**
 * get app token from portal token
 * Returns app token from portal token
 */
export const loginWithTokenMutation = (options?: Partial<Options<LoginWithTokenData>>): UseMutationOptions<LoginWithTokenResponse, DefaultError, Options<LoginWithTokenData>> => {
    const mutationOptions: UseMutationOptions<LoginWithTokenResponse, DefaultError, Options<LoginWithTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWithToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import sample data via CSV or XLSX file
 */
export const postDebugFileImportSampleTestMutation = (options?: Partial<Options<PostDebugFileImportSampleTestData>>): UseMutationOptions<PostDebugFileImportSampleTestResponse, PostDebugFileImportSampleTestError, Options<PostDebugFileImportSampleTestData>> => {
    const mutationOptions: UseMutationOptions<PostDebugFileImportSampleTestResponse, PostDebugFileImportSampleTestError, Options<PostDebugFileImportSampleTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugFileImportSampleTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAppByQreIdSurveyQueryKey = (options: Options<GetAppByQreIdSurveyData>) => createQueryKey('getAppByQreIdSurvey', options);

/**
 * get survey info
 */
export const getAppByQreIdSurveyOptions = (options: Options<GetAppByQreIdSurveyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAppByQreIdSurvey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAppByQreIdSurveyQueryKey(options)
    });
};

/**
 * update sample row
 */
export const postCommandUpdateSampleRowMutation = (options?: Partial<Options<PostCommandUpdateSampleRowData>>): UseMutationOptions<PostCommandUpdateSampleRowResponse, PostCommandUpdateSampleRowError, Options<PostCommandUpdateSampleRowData>> => {
    const mutationOptions: UseMutationOptions<PostCommandUpdateSampleRowResponse, PostCommandUpdateSampleRowError, Options<PostCommandUpdateSampleRowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandUpdateSampleRow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * finalize survey
 */
export const postByQreIdFinalizeSurveyMutation = (options?: Partial<Options<PostByQreIdFinalizeSurveyData>>): UseMutationOptions<PostByQreIdFinalizeSurveyResponse, PostByQreIdFinalizeSurveyError, Options<PostByQreIdFinalizeSurveyData>> => {
    const mutationOptions: UseMutationOptions<PostByQreIdFinalizeSurveyResponse, PostByQreIdFinalizeSurveyError, Options<PostByQreIdFinalizeSurveyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postByQreIdFinalizeSurvey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * delete sample by duplicity
 */
export const postCommandDeleteSampleByDuplicityMutation = (options?: Partial<Options<PostCommandDeleteSampleByDuplicityData>>): UseMutationOptions<PostCommandDeleteSampleByDuplicityResponse, PostCommandDeleteSampleByDuplicityError, Options<PostCommandDeleteSampleByDuplicityData>> => {
    const mutationOptions: UseMutationOptions<PostCommandDeleteSampleByDuplicityResponse, PostCommandDeleteSampleByDuplicityError, Options<PostCommandDeleteSampleByDuplicityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandDeleteSampleByDuplicity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * response codes set
 */
export const postDebugByQreIdResponseCodesSetMutation = (options?: Partial<Options<PostDebugByQreIdResponseCodesSetData>>): UseMutationOptions<unknown, PostDebugByQreIdResponseCodesSetError, Options<PostDebugByQreIdResponseCodesSetData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostDebugByQreIdResponseCodesSetError, Options<PostDebugByQreIdResponseCodesSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugByQreIdResponseCodesSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSampleRowsByQreIdSampleColumnsQueryKey = (options: Options<GetSampleRowsByQreIdSampleColumnsData>) => createQueryKey('getSampleRowsByQreIdSampleColumns', options);

/**
 * get sample columns
 */
export const getSampleRowsByQreIdSampleColumnsOptions = (options: Options<GetSampleRowsByQreIdSampleColumnsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSampleRowsByQreIdSampleColumns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSampleRowsByQreIdSampleColumnsQueryKey(options)
    });
};

/**
 * Import sample data via CSV or XLSX file
 */
export const postCommandFileImportSampleMutation = (options?: Partial<Options<PostCommandFileImportSampleData>>): UseMutationOptions<PostCommandFileImportSampleResponse, PostCommandFileImportSampleError, Options<PostCommandFileImportSampleData>> => {
    const mutationOptions: UseMutationOptions<PostCommandFileImportSampleResponse, PostCommandFileImportSampleError, Options<PostCommandFileImportSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandFileImportSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * pre call info set
 */
export const postByQreIdPreCallInfoSetMutation = (options?: Partial<Options<PostByQreIdPreCallInfoSetData>>): UseMutationOptions<PostByQreIdPreCallInfoSetResponse, PostByQreIdPreCallInfoSetError, Options<PostByQreIdPreCallInfoSetData>> => {
    const mutationOptions: UseMutationOptions<PostByQreIdPreCallInfoSetResponse, PostByQreIdPreCallInfoSetError, Options<PostByQreIdPreCallInfoSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postByQreIdPreCallInfoSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * change response code for sample rows
 */
export const postCommandChangeSampleResponseCodeMutation = (options?: Partial<Options<PostCommandChangeSampleResponseCodeData>>): UseMutationOptions<PostCommandChangeSampleResponseCodeResponse, PostCommandChangeSampleResponseCodeError, Options<PostCommandChangeSampleResponseCodeData>> => {
    const mutationOptions: UseMutationOptions<PostCommandChangeSampleResponseCodeResponse, PostCommandChangeSampleResponseCodeError, Options<PostCommandChangeSampleResponseCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandChangeSampleResponseCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * cati ex alias set
 */
export const postByQreIdCatiExAliasSetMutation = (options?: Partial<Options<PostByQreIdCatiExAliasSetData>>): UseMutationOptions<PostByQreIdCatiExAliasSetResponse, PostByQreIdCatiExAliasSetError, Options<PostByQreIdCatiExAliasSetData>> => {
    const mutationOptions: UseMutationOptions<PostByQreIdCatiExAliasSetResponse, PostByQreIdCatiExAliasSetError, Options<PostByQreIdCatiExAliasSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postByQreIdCatiExAliasSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * get sample row data read model with filters
 */
export const postSurveyByQreIdDefaultFiltersMutation = (options?: Partial<Options<PostSurveyByQreIdDefaultFiltersData>>): UseMutationOptions<PostSurveyByQreIdDefaultFiltersResponse, PostSurveyByQreIdDefaultFiltersError, Options<PostSurveyByQreIdDefaultFiltersData>> => {
    const mutationOptions: UseMutationOptions<PostSurveyByQreIdDefaultFiltersResponse, PostSurveyByQreIdDefaultFiltersError, Options<PostSurveyByQreIdDefaultFiltersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSurveyByQreIdDefaultFilters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update sample data via CSV or XLSX file
 */
export const postDebugFileUpdateSampleTestMutation = (options?: Partial<Options<PostDebugFileUpdateSampleTestData>>): UseMutationOptions<PostDebugFileUpdateSampleTestResponse, PostDebugFileUpdateSampleTestError, Options<PostDebugFileUpdateSampleTestData>> => {
    const mutationOptions: UseMutationOptions<PostDebugFileUpdateSampleTestResponse, PostDebugFileUpdateSampleTestError, Options<PostDebugFileUpdateSampleTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugFileUpdateSampleTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * create sample row
 */
export const postCommandCreateSampleMutation = (options?: Partial<Options<PostCommandCreateSampleData>>): UseMutationOptions<PostCommandCreateSampleResponse, PostCommandCreateSampleError, Options<PostCommandCreateSampleData>> => {
    const mutationOptions: UseMutationOptions<PostCommandCreateSampleResponse, PostCommandCreateSampleError, Options<PostCommandCreateSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandCreateSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export sample data as XLSX file download
 */
export const postCommandByQreIdFileExportSampleMutation = (options?: Partial<Options<PostCommandByQreIdFileExportSampleData>>): UseMutationOptions<unknown, PostCommandByQreIdFileExportSampleError, Options<PostCommandByQreIdFileExportSampleData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostCommandByQreIdFileExportSampleError, Options<PostCommandByQreIdFileExportSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandByQreIdFileExportSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * reset sample
 */
export const postCommandResetSampleMutation = (options?: Partial<Options<PostCommandResetSampleData>>): UseMutationOptions<PostCommandResetSampleResponse, PostCommandResetSampleError, Options<PostCommandResetSampleData>> => {
    const mutationOptions: UseMutationOptions<PostCommandResetSampleResponse, PostCommandResetSampleError, Options<PostCommandResetSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandResetSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSampleByOperationIdOperationStatusQueryKey = (options: Options<GetSampleByOperationIdOperationStatusData>) => createQueryKey('getSampleByOperationIdOperationStatus', options);

/**
 * Get operation status by operation ID (unified endpoint for upload/update/delete)
 */
export const getSampleByOperationIdOperationStatusOptions = (options: Options<GetSampleByOperationIdOperationStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSampleByOperationIdOperationStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSampleByOperationIdOperationStatusQueryKey(options)
    });
};

export const getAppByQreIdImportDatabasesQueryKey = (options: Options<GetAppByQreIdImportDatabasesData>) => createQueryKey('getAppByQreIdImportDatabases', options);

/**
 * Get import databases
 */
export const getAppByQreIdImportDatabasesOptions = (options: Options<GetAppByQreIdImportDatabasesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAppByQreIdImportDatabases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAppByQreIdImportDatabasesQueryKey(options)
    });
};

/**
 * finalize survey
 */
export const postDebugByQreIdFinalizeSurveyMutation = (options?: Partial<Options<PostDebugByQreIdFinalizeSurveyData>>): UseMutationOptions<unknown, PostDebugByQreIdFinalizeSurveyError, Options<PostDebugByQreIdFinalizeSurveyData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostDebugByQreIdFinalizeSurveyError, Options<PostDebugByQreIdFinalizeSurveyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugByQreIdFinalizeSurvey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get last sample update and sample size with optional filters
 */
export const postSampleByQreIdStatusMutation = (options?: Partial<Options<PostSampleByQreIdStatusData>>): UseMutationOptions<PostSampleByQreIdStatusResponse, PostSampleByQreIdStatusError, Options<PostSampleByQreIdStatusData>> => {
    const mutationOptions: UseMutationOptions<PostSampleByQreIdStatusResponse, PostSampleByQreIdStatusError, Options<PostSampleByQreIdStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSampleByQreIdStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * catiex project created
 */
export const postDebugCatiexProjectCreatedMutation = (options?: Partial<Options<PostDebugCatiexProjectCreatedData>>): UseMutationOptions<unknown, PostDebugCatiexProjectCreatedError, Options<PostDebugCatiexProjectCreatedData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostDebugCatiexProjectCreatedError, Options<PostDebugCatiexProjectCreatedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugCatiexProjectCreated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDebugByOperationIdOperationStatusDebugQueryKey = (options: Options<GetDebugByOperationIdOperationStatusDebugData>) => createQueryKey('getDebugByOperationIdOperationStatusDebug', options);

/**
 * Get operation status by operation ID (unified endpoint for upload/update/delete)
 */
export const getDebugByOperationIdOperationStatusDebugOptions = (options: Options<GetDebugByOperationIdOperationStatusDebugData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDebugByOperationIdOperationStatusDebug({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDebugByOperationIdOperationStatusDebugQueryKey(options)
    });
};

/**
 * quota target set
 */
export const postByQreIdQuotaTargetSetMutation = (options?: Partial<Options<PostByQreIdQuotaTargetSetData>>): UseMutationOptions<PostByQreIdQuotaTargetSetResponse, PostByQreIdQuotaTargetSetError, Options<PostByQreIdQuotaTargetSetData>> => {
    const mutationOptions: UseMutationOptions<PostByQreIdQuotaTargetSetResponse, PostByQreIdQuotaTargetSetError, Options<PostByQreIdQuotaTargetSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postByQreIdQuotaTargetSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * get sample row data read model with filters
 */
export const postSampleRowsByQreIdSampleRowDataMutation = (options?: Partial<Options<PostSampleRowsByQreIdSampleRowDataData>>): UseMutationOptions<PostSampleRowsByQreIdSampleRowDataResponse, PostSampleRowsByQreIdSampleRowDataError, Options<PostSampleRowsByQreIdSampleRowDataData>> => {
    const mutationOptions: UseMutationOptions<PostSampleRowsByQreIdSampleRowDataResponse, PostSampleRowsByQreIdSampleRowDataError, Options<PostSampleRowsByQreIdSampleRowDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSampleRowsByQreIdSampleRowData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export sample data as XLSX file download
 */
export const postDebugByQreIdFileExportSampleTestMutation = (options?: Partial<Options<PostDebugByQreIdFileExportSampleTestData>>): UseMutationOptions<unknown, PostDebugByQreIdFileExportSampleTestError, Options<PostDebugByQreIdFileExportSampleTestData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostDebugByQreIdFileExportSampleTestError, Options<PostDebugByQreIdFileExportSampleTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugByQreIdFileExportSampleTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * quota target set
 */
export const postDebugByQreIdQuotaTargetSetMutation = (options?: Partial<Options<PostDebugByQreIdQuotaTargetSetData>>): UseMutationOptions<PostDebugByQreIdQuotaTargetSetResponse, PostDebugByQreIdQuotaTargetSetError, Options<PostDebugByQreIdQuotaTargetSetData>> => {
    const mutationOptions: UseMutationOptions<PostDebugByQreIdQuotaTargetSetResponse, PostDebugByQreIdQuotaTargetSetError, Options<PostDebugByQreIdQuotaTargetSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugByQreIdQuotaTargetSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMetricsQueryKey = (options?: Options<GetMetricsData>) => createQueryKey('getMetrics', options);

/**
 * get prometheus metrics
 */
export const getMetricsOptions = (options?: Options<GetMetricsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMetrics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMetricsQueryKey(options)
    });
};

export const getSampleRowsByQreIdSurveyDataQueryKey = (options: Options<GetSampleRowsByQreIdSurveyDataData>) => createQueryKey('getSampleRowsByQreIdSurveyData', options);

/**
 * get survey data read model
 */
export const getSampleRowsByQreIdSurveyDataOptions = (options: Options<GetSampleRowsByQreIdSurveyDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSampleRowsByQreIdSurveyData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSampleRowsByQreIdSurveyDataQueryKey(options)
    });
};

export const getSurveyByQreIdCatiexProjectLinkQueryKey = (options: Options<GetSurveyByQreIdCatiexProjectLinkData>) => createQueryKey('getSurveyByQreIdCatiexProjectLink', options);

/**
 * get CATIEx project link for survey
 */
export const getSurveyByQreIdCatiexProjectLinkOptions = (options: Options<GetSurveyByQreIdCatiexProjectLinkData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSurveyByQreIdCatiexProjectLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSurveyByQreIdCatiexProjectLinkQueryKey(options)
    });
};

/**
 * cati ex alias set
 */
export const postDebugByQreIdCatiExAliasSetMutation = (options?: Partial<Options<PostDebugByQreIdCatiExAliasSetData>>): UseMutationOptions<PostDebugByQreIdCatiExAliasSetResponse, PostDebugByQreIdCatiExAliasSetError, Options<PostDebugByQreIdCatiExAliasSetData>> => {
    const mutationOptions: UseMutationOptions<PostDebugByQreIdCatiExAliasSetResponse, PostDebugByQreIdCatiExAliasSetError, Options<PostDebugByQreIdCatiExAliasSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugByQreIdCatiExAliasSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * response codes set
 */
export const postByQreIdResponseCodesSetMutation = (options?: Partial<Options<PostByQreIdResponseCodesSetData>>): UseMutationOptions<PostByQreIdResponseCodesSetResponse, PostByQreIdResponseCodesSetError, Options<PostByQreIdResponseCodesSetData>> => {
    const mutationOptions: UseMutationOptions<PostByQreIdResponseCodesSetResponse, PostByQreIdResponseCodesSetError, Options<PostByQreIdResponseCodesSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postByQreIdResponseCodesSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConfigQueryKey = (options?: Options<GetConfigData>) => createQueryKey('getConfig', options);

/**
 * Public runtime configuration for the frontend
 */
export const getConfigOptions = (options?: Options<GetConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConfigQueryKey(options)
    });
};

export const getSampleByQreIdOperationsQueryKey = (options: Options<GetSampleByQreIdOperationsData>) => createQueryKey('getSampleByQreIdOperations', options);

/**
 * Get running operations for qre
 */
export const getSampleByQreIdOperationsOptions = (options: Options<GetSampleByQreIdOperationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSampleByQreIdOperations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSampleByQreIdOperationsQueryKey(options)
    });
};

export const getDebugSurveyByQreIdCatiexProjectLinkQueryKey = (options: Options<GetDebugSurveyByQreIdCatiexProjectLinkData>) => createQueryKey('getDebugSurveyByQreIdCatiexProjectLink', options);

/**
 * get CATIEx project link for survey
 */
export const getDebugSurveyByQreIdCatiexProjectLinkOptions = (options: Options<GetDebugSurveyByQreIdCatiexProjectLinkData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDebugSurveyByQreIdCatiexProjectLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDebugSurveyByQreIdCatiexProjectLinkQueryKey(options)
    });
};

export const getSurveyByQreIdQuotaFlatStructureQueryKey = (options: Options<GetSurveyByQreIdQuotaFlatStructureData>) => createQueryKey('getSurveyByQreIdQuotaFlatStructure', options);

/**
 * get quota (col, val) -> label lookup map for UI formatting
 */
export const getSurveyByQreIdQuotaFlatStructureOptions = (options: Options<GetSurveyByQreIdQuotaFlatStructureData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSurveyByQreIdQuotaFlatStructure({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSurveyByQreIdQuotaFlatStructureQueryKey(options)
    });
};

/**
 * catiex project created
 */
export const postExternalEventsCatiexProjectCreatedMutation = (options?: Partial<Options<PostExternalEventsCatiexProjectCreatedData>>): UseMutationOptions<unknown, PostExternalEventsCatiexProjectCreatedError, Options<PostExternalEventsCatiexProjectCreatedData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostExternalEventsCatiexProjectCreatedError, Options<PostExternalEventsCatiexProjectCreatedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postExternalEventsCatiexProjectCreated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSurveyByQreIdResponseCodesQueryKey = (options: Options<GetSurveyByQreIdResponseCodesData>) => createQueryKey('getSurveyByQreIdResponseCodes', options);

/**
 * get response codes
 */
export const getSurveyByQreIdResponseCodesOptions = (options: Options<GetSurveyByQreIdResponseCodesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSurveyByQreIdResponseCodes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSurveyByQreIdResponseCodesQueryKey(options)
    });
};

/**
 * delete sample
 */
export const postCommandDeleteSampleMutation = (options?: Partial<Options<PostCommandDeleteSampleData>>): UseMutationOptions<PostCommandDeleteSampleResponse, PostCommandDeleteSampleError, Options<PostCommandDeleteSampleData>> => {
    const mutationOptions: UseMutationOptions<PostCommandDeleteSampleResponse, PostCommandDeleteSampleError, Options<PostCommandDeleteSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandDeleteSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update sample data via CSV or XLSX file
 */
export const postCommandFileUpdateSampleMutation = (options?: Partial<Options<PostCommandFileUpdateSampleData>>): UseMutationOptions<PostCommandFileUpdateSampleResponse, PostCommandFileUpdateSampleError, Options<PostCommandFileUpdateSampleData>> => {
    const mutationOptions: UseMutationOptions<PostCommandFileUpdateSampleResponse, PostCommandFileUpdateSampleError, Options<PostCommandFileUpdateSampleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCommandFileUpdateSample({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * pre call info set
 */
export const postDebugByQreIdPreCallInfoSetMutation = (options?: Partial<Options<PostDebugByQreIdPreCallInfoSetData>>): UseMutationOptions<PostDebugByQreIdPreCallInfoSetResponse, PostDebugByQreIdPreCallInfoSetError, Options<PostDebugByQreIdPreCallInfoSetData>> => {
    const mutationOptions: UseMutationOptions<PostDebugByQreIdPreCallInfoSetResponse, PostDebugByQreIdPreCallInfoSetError, Options<PostDebugByQreIdPreCallInfoSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postDebugByQreIdPreCallInfoSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSampleByQreIdMaxIpsosIdQueryKey = (options: Options<GetSampleByQreIdMaxIpsosIdData>) => createQueryKey('getSampleByQreIdMaxIpsosId', options);

/**
 * Get max (numeric) ipsos-id for survey
 */
export const getSampleByQreIdMaxIpsosIdOptions = (options: Options<GetSampleByQreIdMaxIpsosIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSampleByQreIdMaxIpsosId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSampleByQreIdMaxIpsosIdQueryKey(options)
    });
};
